import { colors } from '@ardoq/design-tokens';
import { SpeechBubbleContainer, SpeechBubbleText } from '../atoms';
import { SpeechBubbleProps } from '../types';
import { getSpeechBubblePath, getSpeechBubbleSize } from '../utils';

const SpeechBubble = ({ title, layout }: SpeechBubbleProps) => (
  <SpeechBubbleContainer $layout={layout}>
    <svg {...getSpeechBubbleSize(layout)} role="presentation">
      <path d={getSpeechBubblePath(layout)} fill={colors.blue600} />
    </svg>
    <SpeechBubbleText $layout={layout}>{title}</SpeechBubbleText>
  </SpeechBubbleContainer>
);

export { SpeechBubble };
